// megamenu-content.js — merged and index-based matching
document.addEventListener('DOMContentLoaded', function () {
  function preloadAndSwap(imgEl, src) {
    if (!imgEl || !src) return;
    var current = imgEl.getAttribute('src') || imgEl.src;
    if (current === src) return;
    var i = new Image();
    i.onload = function () { imgEl.setAttribute('src', src); };
    i.src = src;
  }

  function resetPopupToDefault(popup) {
    if (!popup) return;
    var mainImg = popup.querySelector('.hero-main img');
    var subImg  = popup.querySelector('.hero-sub img');
    var defaultMain = mainImg ? (mainImg.getAttribute('data-default-hero') || mainImg.src) : '';
    var defaultSub  = subImg  ? (subImg.getAttribute('data-default-hero')  || subImg.src)  : '';
    if (mainImg && defaultMain) preloadAndSwap(mainImg, defaultMain);
    if (subImg  && defaultSub)  preloadAndSwap(subImg,  defaultSub);
  }

  var currentLockedPopup = null;
  var popups = document.querySelectorAll('#_desktop_top_menu .popover.sub-menu');

  popups.forEach(function (popup) {
    var heroMainImg = popup.querySelector('.hero-main img');
    var heroSubImg  = popup.querySelector('.hero-sub img');
    var defaultMain = heroMainImg ? (heroMainImg.getAttribute('data-default-hero') || heroMainImg.src) : '';
    var defaultSub  = heroSubImg ? (heroSubImg.getAttribute('data-default-hero') || heroSubImg.src) : '';

    // MAIN (left) items — show child-grid + hero when hovered
    popup.querySelectorAll('.mega-first-item').forEach(function (li) {
      var parentHandle = li.getAttribute('data-handle');
      var megaMiddle = popup.querySelector('.mega-middle');
      function openForParent() {
        popup.querySelectorAll('.child-grid').forEach(function (g) { g.classList.remove('active'); });
        var match = popup.querySelector('.child-grid[data-parent-handle="' + parentHandle + '"]');
        if (match) {
          match.classList.add('active');
          if (megaMiddle) megaMiddle.classList.remove('no-child'); // remove if previously added
        } else {
          if (megaMiddle) megaMiddle.classList.add('no-child'); // add when no match
        }

        var anchor = li.querySelector('.mega-first-link');
        if (anchor && anchor.getAttribute('data-hero')) preloadAndSwap(heroMainImg, anchor.getAttribute('data-hero'));
        else preloadAndSwap(heroMainImg, defaultMain);

        if (match) {
          var firstChildAnchor = match.querySelector('.single-child-link[data-hero]');
          if (firstChildAnchor) preloadAndSwap(heroSubImg, firstChildAnchor.getAttribute('data-hero'));
          else {
            var firstGrand = match.querySelector('.grandchild-inline-link[data-hero]');
            if (firstGrand) preloadAndSwap(heroSubImg, firstGrand.getAttribute('data-hero'));
            else preloadAndSwap(heroSubImg, defaultSub);
          }
        } else preloadAndSwap(heroSubImg, defaultSub);

        popup.querySelectorAll('.mega-first-item').forEach(function (x) { x.classList.remove('active'); });
        li.classList.add('active');

        popup.classList.add('has-active');
      }

      li.addEventListener('mouseenter', function () { if (window.innerWidth > 991) openForParent(); });
      var anchor = li.querySelector('.mega-first-link');
      if (anchor) anchor.addEventListener('focus', openForParent);
    });

    // CHILD hover: show grandchild block in the SAME child-grid and preload hero-sub
popup.querySelectorAll('.single-child-link').forEach(function (childAnchor) {
  childAnchor.addEventListener('mouseenter', function () {
    // get the child index from the anchor
    var childIndex = childAnchor.getAttribute('data-child-index');

    // find the child-grid this child belongs to (closest ancestor)
    var parentGrid = childAnchor.closest('.child-grid');
    if (!parentGrid) return;

    // hide all grandchild-blocks in this grid first
    parentGrid.querySelectorAll('.grandchild-block').forEach(function (gb) { gb.classList.remove('active'); });

    // find the grandchild column *inside the same child-grid*
    var grandchildColumn = parentGrid.querySelector('.grandchild-column');

    // if no index or no grandchild column -> ensure column hidden and return
    if (childIndex === null || childIndex === undefined || !grandchildColumn) {
      if (grandchildColumn) grandchildColumn.classList.remove('has-visible');
      return;
    }

    // find the matching grandchild-block inside the same grid by numeric index
    var match = parentGrid.querySelector('.grandchild-block[data-child-index="' + childIndex + '"]');

    if (match) {
      // activate the matched block
      match.classList.add('active');

      // show the grandchild column for this grid
      grandchildColumn.classList.add('has-visible');

      // preload the first grandchild hero into the hero-sub if found
      var firstGrand = match.querySelector('.grandchild-inline-link[data-hero]');
      if (firstGrand && heroSubImg) preloadAndSwap(heroSubImg, firstGrand.getAttribute('data-hero'));
    } else {
      // no grandchildren for this child -> hide the column
      grandchildColumn.classList.remove('has-visible');
    }

    // also ensure the popup shows the middle + hero
    popup.classList.add('has-active');
  });

  // remove the grandchild panel when leaving child if pointer not inside grandchild
  childAnchor.addEventListener('mouseleave', function () {
    setTimeout(function () {
      // if pointer isn't inside any grandchild-block of this specific grid, hide it
      var parentGrid = childAnchor.closest('.child-grid');
      if (!parentGrid) return;
      if (!parentGrid.querySelector('.grandchild-block:hover')) {
        parentGrid.querySelectorAll('.grandchild-block.active').forEach(function (gb) { gb.classList.remove('active'); });
        var gc = parentGrid.querySelector('.grandchild-column');
        if (gc) gc.classList.remove('has-visible');
      }
    }, 120);
  });
});


    // hover/focus on grandchild items should update hero-sub as before
    popup.querySelectorAll('.grandchild-inline-link').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var h = a.getAttribute('data-hero');
        if (h) preloadAndSwap(heroSubImg, h);
      });
      a.addEventListener('focus', function () {
        var h = a.getAttribute('data-hero');
        if (h) preloadAndSwap(heroSubImg, h);
      });
    });

    // reset on leave — hide middle/hero and clear active marks (unless locked)
    popup.addEventListener('mouseleave', function () {
      if (popup.classList.contains('locked')) return;
      popup.querySelectorAll('.child-grid').forEach(function (g) { g.classList.remove('active'); });
      popup.querySelectorAll('.grandchild-block').forEach(function (gb) { gb.classList.remove('active'); });
      popup.querySelectorAll('.mega-first-item').forEach(function (li) { li.classList.remove('active'); });
      var grandchildColumn = popup.querySelector('.grandchild-column');
      if (grandchildColumn) grandchildColumn.classList.remove('has-visible');
      resetPopupToDefault(popup);
      popup.classList.remove('has-active');
    });
  }); // end popups.forEach

  // Helper: find popup for a top-link
  function popupForTopLink(topLink) {
    if (!topLink) return null;
    var popupId = topLink.getAttribute('data-popup');
    if (popupId) {
      var byId = document.getElementById(popupId);
      if (byId) return byId;
    }
    var parentLi = topLink.closest('li');
    if (parentLi) return parentLi.querySelector('.popover.sub-menu');
    return null;
  }

  // TOP-LINK hover: open popup & lock it, but reset selection (show only left column)
  document.querySelectorAll('#_desktop_top_menu .top-link').forEach(function (topLink) {
    function applySpecialAndLock() {
      if (window.innerWidth <= 991) return;
      var popup = popupForTopLink(topLink);
      if (!popup) return;

      // reset previous locked popup fully
      if (currentLockedPopup && currentLockedPopup !== popup) {
        currentLockedPopup.classList.remove('locked', 'has-active');
        resetPopupToDefault(currentLockedPopup);
        currentLockedPopup.querySelectorAll('.child-grid').forEach(function (g) { g.classList.remove('active'); });
        currentLockedPopup.querySelectorAll('.mega-first-item').forEach(function (li) { li.classList.remove('active'); });
        currentLockedPopup.querySelectorAll('.grandchild-block').forEach(function (gb) { gb.classList.remove('active'); });
        var prevGrand = currentLockedPopup.querySelector('.grandchild-column');
        if (prevGrand) prevGrand.classList.remove('has-visible');
      }

      // Reset THIS popup to default: no selection shown except left column
      popup.classList.remove('has-active');
      popup.querySelectorAll('.child-grid').forEach(function (g) { g.classList.remove('active'); });
      popup.querySelectorAll('.mega-first-item').forEach(function (li) { li.classList.remove('active'); });
      popup.querySelectorAll('.grandchild-block').forEach(function (gb) { gb.classList.remove('active'); });
      var grandchildColumn = popup.querySelector('.grandchild-column');
      if (grandchildColumn) grandchildColumn.classList.remove('has-visible');
      resetPopupToDefault(popup);

      // Lock so it stays open showing only left column
      popup.classList.add('locked');
      currentLockedPopup = popup;
    }

    topLink.addEventListener('mouseenter', applySpecialAndLock);
    topLink.addEventListener('focus', applySpecialAndLock);
  });

  // click outside -> unlock and reset
  document.addEventListener('click', function (e) {
    var menu = document.getElementById('_desktop_top_menu');
    if (!menu) return;
    if (menu.contains(e.target)) return;
    if (currentLockedPopup) {
      currentLockedPopup.classList.remove('locked', 'has-active');
      resetPopupToDefault(currentLockedPopup);
      currentLockedPopup.querySelectorAll('.child-grid').forEach(function (g) { g.classList.remove('active'); });
      currentLockedPopup.querySelectorAll('.mega-first-item').forEach(function (li) { li.classList.remove('active'); });
      currentLockedPopup.querySelectorAll('.grandchild-block').forEach(function (gb) { gb.classList.remove('active'); });
      var gc = currentLockedPopup.querySelector('.grandchild-column');
      if (gc) gc.classList.remove('has-visible');
      currentLockedPopup = null;
    }
  });

  // mobile toggle
  document.querySelectorAll('#_desktop_top_menu .top-link').forEach(function (topLink) {
    topLink.addEventListener('click', function (e) {
      if (window.innerWidth <= 991) {
        e.preventDefault();
        var parentLi = topLink.closest('li');
        if (parentLi) {
          var opened = parentLi.classList.toggle('open');
          var dp = parentLi.querySelector('.sub-menu');
          if (dp) dp.setAttribute('aria-hidden', opened ? 'false' : 'true');
        }
      }
    });
  });

}); // DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  const middleTitle = document.getElementById("mega-middle-title");

  document.querySelectorAll(".mega-first-item").forEach(item => {
    item.addEventListener("mouseenter", () => {
      const title = item.dataset.title;
      if (title && middleTitle) {
        middleTitle.textContent = title;
      }
    });
  });
});
